import React from 'react';
import Moment from "react-moment";
import "moment-timezone";
import { Sort } from '@material-ui/icons';

// Set the timezone for every instance.
// Use local timezone instead of forcing UTC
// Moment.globalTimezone = "UTC";

function lastSchedule(list){
  return list.sort(compare);
}

function compare(a, b) {
  if (a.id > b.id) return -1;
  if (b.id > a.id) return 1;
  return 0;
}

export default function IntegrationButton(props, selectIntegration) {
                 return (
                   <>
                     {props.EmployeeStatus && props.EmployeeStatus.id === 4 ? (
                       props.IntegrationSchedules.length ? (
                         <div>
                          <span
                            data-toggle="modal"
                            data-target=".modal-integration"
                            className="btn btn-rounded btn-outline-primary"
                            onClick={() => selectIntegration(props.id)}
                          >
                            <i className="fa fa-clock-o"></i> Integração
                          </span><br></br>
                          <small>Último agendamento: <br></br>
                            <Moment format="DD/MM/YYYY HH:mm">{lastSchedule(props.IntegrationSchedules)[0].updatedAt}</Moment>  
                            <br></br> 
                            Integração: {(props.IntegrationSchedules)[0].IntegrationId}                            
                            
                          </small>
                         </div>
                       ) : (
                         <span
                           data-toggle="modal"
                           data-target=".modal-integration"
                           className="btn btn-rounded btn-outline-primary"
                           onClick={() => selectIntegration(props.id)}
                         >
                           <i className="fa fa-clock-o"></i> Integração
                         </span>
                       )
                     ) : null}
                   </>
                 );
               };